import { detectOS, isUndefined, osResourceAttributes } from "@posthog/core";
const DEFAULT_FLUSH_INTERVAL_MS = 3000;
const DEFAULT_MAX_BUFFER_SIZE = 100;
const DEFAULT_MAX_LOGS_PER_INTERVAL = 1000;
const DEFAULT_CONSOLE_MAX_QUEUE_SIZE = 2048;
const DEFAULT_MAX_BATCH_RECORDS_PER_POST = 100;
function defaultResourceAttributes() {
    let osName = '';
    let osVersion = '';
    try {
        const browserGlobal = "u" > typeof globalThis ? globalThis : "u" > typeof window ? window : void 0;
        const userAgent = browserGlobal?.navigator?.userAgent;
        if (userAgent) [osName, osVersion] = detectOS(userAgent);
    } catch  {}
    return osResourceAttributes(osName, osVersion);
}
function resolveLogsConfig(config, opts) {
    const flushIntervalMs = config?.flushIntervalMs ?? DEFAULT_FLUSH_INTERVAL_MS;
    const maxBufferSize = config?.maxBufferSize ?? DEFAULT_MAX_BUFFER_SIZE;
    const maxLogsPerInterval = opts?.consoleCapture ? void 0 : config?.maxLogsPerInterval ?? DEFAULT_MAX_LOGS_PER_INTERVAL;
    const maxQueueSize = isUndefined(maxLogsPerInterval) ? Math.max(maxBufferSize, DEFAULT_CONSOLE_MAX_QUEUE_SIZE) : Math.max(maxBufferSize, maxLogsPerInterval);
    const resourceAttributes = {
        ...defaultResourceAttributes(),
        ...config?.resourceAttributes
    };
    return {
        serviceName: resourceAttributes?.['service.name'] ?? config?.serviceName ?? opts?.serviceNameDefault,
        serviceVersion: resourceAttributes?.['service.version'] ?? config?.serviceVersion,
        environment: resourceAttributes?.['deployment.environment'] ?? config?.environment,
        resourceAttributes,
        beforeSend: config?.beforeSend,
        flushIntervalMs,
        maxBufferSize,
        maxQueueSize,
        maxBatchRecordsPerPost: DEFAULT_MAX_BATCH_RECORDS_PER_POST,
        rateCapWindowMs: flushIntervalMs,
        maxLogsPerInterval,
        backgroundFlushBudgetMs: 0,
        terminationFlushBudgetMs: 0
    };
}
export { resolveLogsConfig };
